<template>
  <div :class="$style.detail">
    <header v-if="!hiddenTitle">
      <div @click="goBack">
        <i class="iconfont yw-xiangzuo"></i>
      </div>
      <span>{{ detailTitle }}</span>
    </header>
    <p
      :class="$style.content"
      v-html="detailContent ? detailContent.replace(/(\r\n|\n|\r)/gm, '<br />') : ''"
    ></p>
  </div>
</template>

<script>

import { setPageTitle } from '@/bridge/AppJsBridge';
import { checkIsWxBrowser } from "@/libs/utils";

export default {
  data() {
    return {
      detailTitle: "详情页",
      detailContent: null,
      hiddenTitle: false,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const { history } = this.$router;
      const { params } = history.current;
      setPageTitle(params.title);
      this.detailTitle = params.title;
      this.detailContent = params.content;

      if (params.cookie) {
        this.hiddenTitle = true;
      }
      if (checkIsWxBrowser()) {
        this.hiddenTitle = true;
      }
    },
    goBack() {
      this.$router.back()
    },
  },
};
</script>

<style lang="scss" module>
.detail {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  padding-top: 50px;
  padding-bottom: 80px;
  overflow: auto;
  &.hiddenTitle {
    padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 3;
    background: #ffffff;
    color: #000000;
    font-size: 19px;
    padding: 14px 5px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      font-weight: bold;
      position: absolute;
    }
    > span {
      font-size: 18px;
      font-weight: 700;
      margin: 0 auto;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 20px;
    font-family: Source Han Sans CN, Source Han Sans CN-Bold;
    font-weight: 700;
    color: black;
    line-height: 36px;
  }
  .content{
    margin: 10px;
    color: #666666;
    font-weight: 500;
    font-size: 12.5px;
  }
  :global {
    .iconfont {
      font-size: 22px;
      margin-right: 5px;
    }
  }
}
</style>
